module.exports = __webpack_public_path__ + "img/noimage.bd696be2.svg";